<section class="users-page">
  <!-- Title + actions row -->
  <div class="d-flex align-items-center justify-content-between mb-3">
    <div>
      <h3 class="title mb-1">Verification Requests</h3>
      <p class="subtitle page-desc mb-0">
        Manage and review user verification requests.
      </p>
    </div>
  </div>

  <!-- Search row -->
  <div class="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-3">
    <div class="d-flex align-items-center gap-2">
      <app-search-box tooltipText="Search By name and email" [value]="searchTerm()"
      (search)="onSearch($event)"></app-search-box>

      <div class="position-relative d-flex align-items-center">
        <select class="form-select" [ngModel]="filterStatus()" (ngModelChange)="onStatusChange($event)"
          style="min-width: 140px; width: auto; border-radius: 8px; height: 42px; flex-shrink: 0; padding-right: 44px;">
          <option value="all">All Statuses</option>
          <option value="pending">Pending</option>
          <option value="verified">Verified</option>
          <option value="rejected">Rejected</option>
          <option value="expired">Expired</option>
          <option value="failed">Failed</option>
        </select>
        @if (filterStatus() !== 'all') {
          <button type="button" class="btn btn-link p-0 position-absolute" (click)="onStatusChange('all')"
            style="right: 32px; z-index: 10; color: #6b7280; font-size: 1rem; border: none; background: transparent; cursor: pointer;"
            title="Clear filter">
            ✕
          </button>
        }
      </div>



      @if(hasSelection()){
        <button class="btn btn-icon btn-delete-bulk" (click)="bulkDelete()" title="Delete Selected">
          <i class="pi pi-trash"></i>
        </button>
      }

    </div>

    <div class="d-flex align-items-center gap-3 ms-auto">
      <div class="d-flex align-items-center gap-2 border rounded px-1 header-icon-actions-wrapper"
        style="height: 38px;">
        <button type="button" class="btn btn-icon p-1 header-icon-action-btn" title="Refresh">
          <i class="pi pi-refresh" style="font-size: 1.25rem; color: #6b7280;"></i>
        </button>
        <button type="button" class="btn btn-icon p-1 tooltip-wrap header-icon-action-btn">
          <i class="pi pi-asterisk" style="font-size: 1.25rem; color: #6b7280;"></i>
          <span class="tooltip-box">Include Mark Deleted</span>
        </button>
      </div>
    </div>
  </div>

  <div class="table-container shadow">
    <table class="user-table">
      <thead>
        <tr>
          <th class="checkbox-col" style="width: 48px;">
            <input type="checkbox" [checked]="allSelected()" (change)="toggleSelectAll()" />
          </th>
          <th class="sortable" (click)="onSort('name')">
            User <span class="sort-indicator" [class.active]="currentSortField() === 'name'">{{ getSortIcon('name')
          }}</span>
        </th>
        <th class="sortable" (click)="onSort('email')">
          Email <span class="sort-indicator" [class.active]="currentSortField() === 'email'">{{ getSortIcon('email')
        }}</span>
      </th>
      <th class="sortable" (click)="onSort('submittedAt')">
        Submitted At <span class="sort-indicator" [class.active]="currentSortField() === 'submittedAt'">{{
      getSortIcon('submittedAt') }}</span>
    </th>
    <th class="sortable text-center" (click)="onSort('type')">
      Type <span class="sort-indicator" [class.active]="currentSortField() === 'type'">{{ getSortIcon('type')
    }}</span>
  </th>
  <th class="sortable text-center" (click)="onSort('status')">
    Status <span class="sort-indicator" [class.active]="currentSortField() === 'status'">{{
  getSortIcon('status') }}</span>
</th>
<th class="text-center">Action</th>
</tr>
</thead>
<tbody>
  @if (loading()) {
    <tr>
      <td colspan="100%" class="text-center py-5">
        <app-spinner-loader [width]="35"></app-spinner-loader>
      </td>
    </tr>
  } @else if (paginatedRequests().length === 0) {
    <tr>
      <td colspan="100%" class="no-data-cell text-center py-4">No verification requests found</td>
    </tr>
  } @else {
    @for (r of paginatedRequests(); track r) {
      <tr [class.selected]="r.selected">
        <td class="checkbox-col">
          <input type="checkbox" [(ngModel)]="r.selected" (change)="syncSelectAll()" />
        </td>
        <td>
          <div class="d-flex align-items-center gap-2">
            <div class="avatar position-relative"
              style="width: 38px; height: 38px; border-radius: 50%; background: #f3f4f6; display: flex; align-items: center; justify-content: center; overflow: hidden; flex-shrink: 0;">
              <img [src]="r.avatarUrl || 'assets/images/profile.png'" alt="Profile"
                style="width: 100%; height: 100%; object-fit: cover;" />
              </div>
              <div class="d-flex flex-column gap-1">
                <span class="fw-semibold" style="color: #1f2937;">{{ r.name }}</span>
                <div class="d-flex align-items-center gap-2">
                  @if (r.hasId) {
                    <span title="ID Submitted" style="font-size: 0.95rem; cursor: help;">📄</span>
                  }
                  @if (r.hasSelfie) {
                    <span title="Selfie Submitted" style="font-size: 0.95rem; cursor: help;">📷</span>
                  }
                </div>
              </div>
            </div>
          </td>
          <td class="text-muted">{{ r.email }}</td>
          <td class="text-muted">{{ r.submittedAt }}</td>
          <td class="text-center">
            <span class="badge text-dark bg-secondary-subtle border"
            style="font-size: 0.8rem; padding: 4px 8px; border-radius: 6px;">{{ r.type }}</span>
          </td>
          <td class="text-center">
            @if (r.status === 'pending') {
              <span class="badge" style="background: #fff7ed; color: #fb923c;"
              >Pending</span>
            }
            @if (r.status === 'verified') {
              <span class="badge" style="background: #e9f9ef; color: #16a34a;"
              >Verified</span>
            }
            @if (r.status === 'rejected') {
              <span class="badge" style="background: #fee2e2; color: #ef4444;"
              >Rejected</span>
            }
            @if (r.status === 'expired') {
              <span class="badge" style="background: #fee2e2; color: #ef4444;"
              >Expired</span>
            }
            @if (r.status === 'failed') {
              <span class="badge" style="background: #fee2e2; color: #ef4444;">Failed</span>
            }
          </td>
          <td class="text-center">
            <button class="btn btn-view" (click)="openViewModal(r)">View</button>
          </td>
        </tr>
      }
    }
  </tbody>
</table>

<div class="pagination-section">
  <div class="pagination-info">
    <span>
      Showing {{ startIndex() }} to {{ endIndex() }} of
      {{ totalCount() }} Entries
    </span>
  </div>
  <div class="d-flex gap-2">
    @if (paginatedRequests().length !== 0) {
      <label class="page-size-label" for="pageSizeSelect">Page Size:</label>
      <select id="pageSizeSelect" [ngModel]="pageSize()" (ngModelChange)="onPageSizeChange($event)"
        class="form-select" style="width: 70px;">
        @for (size of pageSizes; track size) {
          <option [value]="size">
            {{ size }}
          </option>
        }
      </select>
    }
    <button class="btn btn-outline pagination-btn"
      [disabled]="currentPage() === 1 || paginatedRequests().length === 0" (click)="prevPage()">
      &lt; Prev
    </button>
    <button class="btn btn-outline pagination-btn" [disabled]="currentPage() === totalPages()" (click)="nextPage()">
      Next &gt;
    </button>
  </div>
</div>
</div>
</section>

<!-- View Modal -->
@if (isModalOpen) {
  <div class="modal-backdrop" (click)="closeViewModal()">
    <div class="modal-dialog custom-modal" (click)="$event.stopPropagation()">
      <div class="modal-content">
        <div class="modal-header border-bottom">
          <h5 class="modal-title">Verification Request Details</h5>
          <button type="button" class="btn-close" (click)="closeViewModal()"></button>
        </div>
        @if (selectedRequest) {
          <div class="modal-body p-4">
            <div class="d-flex align-items-center gap-3 mb-4">
              <img [src]="selectedRequest.avatarUrl || 'assets/images/profile.png'" alt="Avatar"
                style="width: 64px; height: 64px; border-radius: 50%; object-fit: cover;">
                <div>
                  <h4 class="mb-1">{{ selectedRequest.name }}</h4>
                  <p class="text-muted mb-0">{{ selectedRequest.email }}</p>
                </div>
              </div>
              <div class="mb-4">
                <h6>Status</h6>
                @if (selectedRequest.status === 'pending') {
                  <span class="badge" style="background: #fff7ed; color: #fb923c;"
                  >Pending</span>
                }
                @if (selectedRequest.status === 'verified') {
                  <span class="badge" style="background: #e9f9ef; color: #16a34a;"
                  >Verified</span>
                }
                @if (selectedRequest.status === 'rejected') {
                  <span class="badge" style="background: #fee2e2; color: #ef4444;"
                  >Rejected</span>
                }
                <div class="mt-2 text-muted" style="font-size: 0.9rem;">
                  <div>Submitted: {{ selectedRequest.submittedAt }}</div>
                  @if (selectedRequest.approvedAt) {
                    <div>Reviewed: {{ selectedRequest.approvedAt }}</div>
                  }
                </div>
              </div>
              <div class="mb-4">
                <h6>Documents Submitted</h6>
                <div class="d-flex gap-3 mt-2">
                  <div
                    class="border rounded p-3 text-center flex-fill bg-light d-flex flex-column align-items-center justify-content-center"
                    style="min-height: 180px;">
                    @if (selectedRequest.sourceImage) {
                      <img [src]="selectedRequest.sourceImage" alt="ID Document" class="img-thumbnail"
                        style="max-height: 120px; max-width: 100%; object-fit: contain; cursor: pointer; border-radius: 6px;"
                        (click)="openImage(selectedRequest.sourceImage)">
                      } @else {
                        <div style="font-size: 2rem;">📄</div>
                      }
                      <div class="mt-2 fw-semibold" style="font-size: 0.85rem;">ID Document</div>
                    </div>
                    <div
                      class="border rounded p-3 text-center flex-fill bg-light d-flex flex-column align-items-center justify-content-center"
                      style="min-height: 180px;">
                      @if (selectedRequest.targetImage) {
                        <img [src]="selectedRequest.targetImage" alt="Selfie" class="img-thumbnail"
                          style="max-height: 120px; max-width: 100%; object-fit: contain; cursor: pointer; border-radius: 6px;"
                          (click)="openImage(selectedRequest.targetImage)">
                        } @else {
                          <div style="font-size: 2rem;">📷</div>
                        }
                        <div class="mt-2 fw-semibold" style="font-size: 0.85rem;">Selfie</div>
                      </div>
                    </div>
                  </div>
                </div>
              }
              @if (selectedRequest?.status === 'pending') {
                <div class="modal-footer border-top bg-light justify-content-end">
                  <button class="btn btn-action-reject me-2" (click)="reject(selectedRequest!.id)">
                    <i class="pi pi-times"></i> Reject
                  </button>
                  <button class="btn btn-action-approve" (click)="approve(selectedRequest!.id)">
                    <i class="pi pi-check"></i> Approve
                  </button>
                </div>
              }
              @if (selectedRequest?.status !== 'pending') {
                <div class="modal-footer border-top bg-light justify-content-end">
                  <button class="btn btn-secondary" (click)="closeViewModal()">Close</button>
                </div>
              }
            </div>
          </div>
        </div>
      }